var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove_svg__remove_svg__Canvas",
    transform: "translate(16415 1126)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remove_svg__remove_svg__close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remove_svg__remove_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#remove_svg__remove_svg__path0_fill",
    transform: "translate(-16415 -1126)",
    fill: "#4F4F4F"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "remove_svg__remove_svg__path0_fill",
    d: "M 16 1.79281L 14.2072 1.29038e-07L 8 6.20719L 1.79281 1.29038e-07L 1.29038e-07 1.79281L 6.20719 8L 1.29038e-07 14.2072L 1.79281 16L 8 9.79281L 14.2072 16L 16 14.2072L 9.79281 8L 16 1.79281Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.4029755bb63934875774e22bf29d8e0c.svg";
export { ForwardRef as ReactComponent };